module.exports = __webpack_public_path__ + "a1d0d746f64d10eb22cc2f229f70e971.svg";